// InvoiceStatusChip — чип вычисляемого статуса счёта (V14 W6, §3.8).
// Цвета: DRAFT — default (нейтр.), OPEN — info (синий), PARTIAL — warning (оранжевый),
// PAID — success (зелёный), OVERDUE — error (красный), VOID — default (серый, terminal).
import { Chip } from '@mui/material';
import type { InvoiceStatus } from '@/api/invoices';
import { formatInvoiceStatus } from '@/lib/format';
import { t } from '@/i18n';

/** Цвет чипа по статусу (палитры §3.8: PAID-green / PARTIAL-orange / OVERDUE-red / OPEN-blue / VOID-gray). */
const STATUS_COLOR: Record<InvoiceStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
  DRAFT: 'default',
  OPEN: 'info',
  PARTIAL: 'warning',
  PAID: 'success',
  OVERDUE: 'error',
  VOID: 'default',
};

/** Цвет статуса для чипов-фильтров и статус-чипов (единая палитра — DRY, канон paymentStatusColor). */
export function invoiceStatusColor(status: InvoiceStatus): 'default' | 'info' | 'warning' | 'success' | 'error' {
  return STATUS_COLOR[status];
}

/** MD3 Chip со статусом счёта (локализованная подпись — U-16). */
export function InvoiceStatusChip({ status }: { status: InvoiceStatus }): JSX.Element {
  return <Chip size="small" color={invoiceStatusColor(status)} label={formatInvoiceStatus(status, t)} />;
}
